export const MCAdminUserLogin='MCAdminUserLogin'
export const MCAdminUserDetails= 'MCAdminUserDetails'
export const MCAdminUserCreate ='MCAdminUserCreate'
export const MCAdminUserList = 'MCAdminUserList'
export const MCAdminUserUpdate = 'MCAdminUserUpdate'

export const CountryList = 'CountryList'
export const StateList = 'StateList' 

export const MCMemberList = 'MCMemberList'
export const MCMemberDetails = 'MCMemberDetails'
export const MCMemberUpdate = 'MCMemberUpdate'
export const MCMemberProductDetails = 'MCMemberProductDetails'
export const MCMemberProductUpdate = 'MCMemberProductUpdate'

export const MCMemberPasswordUpdate = 'MCMemberPasswordUpdate'

